export default __webpack_public_path__ + "static/media/star_half.c0d1706f.svg";